import { useState } from 'react';
import {
  Box,
  Button,
  List,
  ListItemButton,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export default function ChatSidebar({
  chats = [],
  selectedChatId,
  onNewChat = () => {},
  onSelectChat = () => {},
  onDeleteChat,
  onRenameChat
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuChatId, setMenuChatId] = useState(null);
  const [hoveredChatId, setHoveredChatId] = useState(null);
  const [renameOpen, setRenameOpen] = useState(false);
  const [renameValue, setRenameValue] = useState('');
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [actionChatId, setActionChatId] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, chatId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget.closest('[data-chat-item]'));
    setMenuChatId(chatId);
    setActionChatId(chatId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const cleanTitle = (title) =>
  title?.replace(/^#+\s*/, '').trim() || 'New chat';


  return (
    <>
      <Box sx={{ width: 280, borderRight: '1px solid #eee', p: 2, height: '100vh', overflowY: 'auto' }}>
        {/* ✅ CREATE NEW CHAT */}
        <Button fullWidth variant="outlined" onClick={onNewChat}>
          + New Chat
        </Button>

        {/* ✅ CHAT LIST */}
        <List sx={{ mt: 2 }}>
          {chats.map((chat) => (
            <ListItemButton
              data-chat-item
              key={chat.id}
              onMouseEnter={() => setHoveredChatId(chat.id)}
              onMouseLeave={() => setHoveredChatId(null)}
              selected={chat.id === selectedChatId}
              onClick={() => onSelectChat(chat.id)}
              // sx={{
              //   display: 'flex',
              //   justifyContent: 'space-between',
              //   '&:hover .chat-actions': { opacity: 1 }
              // }}
            >
              <Typography noWrap fontSize={14} sx={{ flex: 1 }} title={cleanTitle(chat.title)}>
                {cleanTitle(chat.title)}
              </Typography>

              <Box
                sx={{
                  width: 32,
                  display: 'flex',
                  justifyContent: 'center',
                  opacity: hoveredChatId === chat.id ? 1 : 0,
                  pointerEvents: hoveredChatId === chat.id ? 'auto' : 'none',
                  transition: 'opacity 0.15s ease'
                }}
              >
                <IconButton size="small" onClick={(e) => handleMenuOpen(e, chat.id)}>
                  <MoreHorizIcon fontSize="small" />
                </IconButton>
              </Box>
            </ListItemButton>
          ))}
        </List>

        {/* ✅ MENU */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
          transformOrigin={{ vertical: 'center', horizontal: 'right' }}
          PaperProps={{
            sx: {
              borderRadius: 1.5,
              boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
            }
          }}
        >
          <MenuItem
            disabled={!onRenameChat}
            onClick={() => {
              const chat = chats.find((c) => c.id === menuChatId);
              setRenameValue(chat?.title || 'New Chat');
              setRenameOpen(true);
              handleMenuClose();
            }}
            sx={{
              fontSize: 14,
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
          >
            <EditOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
            Rename
          </MenuItem>

          <MenuItem
            disabled={!onDeleteChat}
            onClick={() => {
              setDeleteOpen(true);
              handleMenuClose();
            }}
            sx={{
              fontSize: 14,
              color: 'error.main',
              '&:hover': { bgcolor: '#fdecea' }
            }}
          >
            <DeleteOutlineIcon fontSize="small" sx={{ mr: 1 }} />
            Delete
          </MenuItem>
        </Menu>
      </Box>
      <Dialog open={renameOpen} onClose={() => setRenameOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Rename chat</DialogTitle>
        <DialogContent>
          <TextField autoFocus fullWidth size="small" value={renameValue} onChange={(e) => setRenameValue(e.target.value)} sx={{ mt: 1 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRenameOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              onRenameChat?.(actionChatId, renameValue);
              setRenameOpen(false);
              setMenuChatId(null);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Delete chat?</DialogTitle>
        <DialogContent>This will permanently delete the chat and its messages.</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              onDeleteChat?.(actionChatId);
              setDeleteOpen(false);
              setMenuChatId(null);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
